import { Locale } from "../Locale.js";
import { localizePathMap } from "./localizePathMap.js";

export const blogPathMap = localizePathMap({
	[Locale.cs]: "blog",
	[Locale.en]: "blog",
});
